import { RegisterForm } from "../containers/forms/register";
import { Mail } from "lucide-react";
import logoIcon from "@surgia/ui/icons/sidebar/logo.svg";
import iconPatternUrl from "@surgia/ui/icons/backgrounds/line-pattern.svg";
import courierMaskUrl from "@surgia/ui/icons/backgrounds/courier-mask.svg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
const RegisterPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="lg:bg-background flex min-h-screen justify-center">
        <div className="bg-background m-0 flex max-w-screen-xl flex-1 justify-center overflow-hidden sm:m-10 sm:rounded-4xl md:shadow">
          <div className="bg-background flex flex-1 flex-col items-center justify-between p-8 lg:max-w-1/2">
            <nav className="flex self-start pt-2 pb-12 md:pb-8">
              <a href="/">
                <img
                  src={logoIcon}
                  width={200}
                  height={200 * (83 / 256)}
                  alt="Surgia Logo"
                  style={{ maxWidth: "125px", aspectRatio: "256/83" }}
                />
              </a>
            </nav>
            <div>
              <h1 className="mb-3 text-2xl font-semibold xl:text-3xl">
                {t("hub.register.pageTitle")}
              </h1>
              <p className="mb-8 text-sm text-gray-600 lg:text-base">
                {t("hub.register.pageSubtitle")}
              </p>
              <RegisterForm />
              <div className="flex w-full max-w-sm justify-center gap-1 text-sm mt-8">
                <p className="text-gray-600">Already have an account?</p>
                <Link
                  to="/login"
                  className="text-primary text-sm font-semibold hover:underline text-[#822cf0]"
                >
                  Sign in
                </Link>
              </div>
            </div>
            <div className="flex self-end pt-12 pb-2 md:pt-8">
              <a href={`mailto:${t("hub.register.contactEmail")}`}>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <span>
                    <Mail size={16} />
                  </span>
                  <p>{t("hub.register.contactEmail")}</p>
                </div>
              </a>
            </div>
          </div>
          {/* Decoration Image for Large Screens */}
          <div className="hidden flex-1 items-center justify-center bg-[#F4F0F9] lg:flex">
            <div className="relative h-full w-full">
              <div
                className="absolute h-full w-full bg-no-repeat"
                style={{
                  backgroundImage: `url(${iconPatternUrl}), url(${iconPatternUrl})`,
                  backgroundPosition: "top right, bottom -200px left",
                  backgroundSize: "50% auto, 50% auto",
                }}
              ></div>
              <div
                className="relative z-10 h-full w-full bg-left bg-no-repeat"
                style={{
                  backgroundImage: `url(${courierMaskUrl})`,
                  backgroundSize: "contain",
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterPage;
